import * as L from "leaflet";
import "leaflet/dist/leaflet.css";
import { GestureHandling } from "leaflet-gesture-handling";
// import initMarkers from "./marker.js";

import "leaflet/dist/leaflet.css";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";

import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

export default function initMap() {
    const mapElement = document.getElementById("map");
    if (!mapElement) return;

    // const map = L.map('map', {
    //     scrollWheelZoom: false,
    //     gestureHandling: true,
    // }).setView([51.505, -0.09], 13);

    // L.tileLayer(
    //     'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}' +
    //     (L.Browser.retina ? '@2x.png' : '.png'),
    //     {
    //         attribution:
    //             '&copy; OpenStreetMap &copy; CARTO'
    //     }
    // ).addTo(map);

    // initMarkers(map);
    L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);

    let map = L.map('map', {
        scrollWheelZoom: false, // disables zooming with mouse wheel
        // dragging: false,        // disables map dragging
        // touchZoom: false,       // disables pinch zoom
        // doubleClickZoom: false, // disables zoom on double click
        // boxZoom: false,         // disables zoom with box selection
        // keyboard: false,         // disables keyboard navigation
        gestureHandling: true,
    }).setView([51.505, -0.09], 13);

    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}' + (L.Browser.retina ? '@2x.png' : '.png'), {
        attribution:'&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>',
    }).addTo(map);
    // L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    // 	attribution:'&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>',
    // }).addTo(map);
    let bounds = L.latLngBounds();
    let markers = {};


    delete L.Icon.Default.prototype._getIconUrl;

    L.Icon.Default.mergeOptions({
        iconRetinaUrl: markerIcon2x,
        iconUrl: markerIcon,
        shadowUrl: markerShadow,
    });
    // let customIcon = L.icon({
    //     iconUrl: 'https://cdn-icons-png.flaticon.com/512/833/833593.png',
    //     iconSize: [40, 40],
    //     iconAnchor: [20, 40],
    //     popupAnchor: [0, -40]
    // });

    document.querySelectorAll('#locations li').forEach(loc => {
        let location = loc.dataset.location.split(/[ ,]+/);
        let lat = parseFloat(location[0]);
        let lng = parseFloat(location[1]);
        let zoom = location[2] ?? 4;

        let marker = L.marker([lat, lng], {keyboard: false}).addTo(map);
        // <span>&copy;${loc.dataset.credit}</span></h4>
        marker.bindPopup(`
            <img src="${loc.dataset.image}">
            <h4><strong>${loc.innerText}</strong>
            <p>${loc.dataset.address}</p>
            <p>${loc.dataset.location}</p>
        `);
        // marker.bindPopup(`<b>${loc.innerText}</b>`);

        bounds.extend(marker.getLatLng());
        markers[loc.dataset.location] = marker;

        marker.on('click', () => {
            map.setView([lat, lng], zoom);
            marker.openPopup();
        });
    });

    map.fitBounds(bounds, {
        padding: [50, 50]
    });

    document.querySelectorAll('#locations li').forEach(el => {
        el.addEventListener('click', (event) => {
            let location = event.currentTarget.dataset.location.split(/[ ,]+/);
            let lat = parseFloat(location[0]);
            let lng = parseFloat(location[1]);
            let zoom = location[2] ?? 16;

            map.setView([lat, lng], zoom);

            let marker = markers[event.currentTarget.dataset.location];
            if (marker) marker.openPopup();

            /**
             * Feature detect smooth scrolling
             * https://thelinuxcode.com/scroll-to-id-javascript/
             */

            let scrollBehavior = "auto";

            if ("scrollBehavior" in document.documentElement.style) {
                scrollBehavior = "smooth";
            }

            document.querySelector("#map").scrollIntoView({
                behavior: scrollBehavior
            });
        });
    });

    // map.on('click', function () {
    // 	map.scrollWheelZoom.enable();
    // });

    // // Disable again when mouse leaves map
    // map.on('mouseout', function () {
    // 	map.scrollWheelZoom.disable();
    // });
}
